// Pharmascience — a quiz submission was REFUSED by the server (2026-09-11).
//
// bnrmp-quiz-access-policy.php answers the WpProQuiz completion POST with
// HTTP 409 when the quiz is already passed (locked) or its module's topics are
// unfinished (gated). LearnDash's own JS only handles `success`, so on 409 it
// would sit on its "sending" bar with an UNSAVED result. Reloading lets the
// server render the locked / gate panel it already owns — no second copy of
// that copy lives here, and nothing here decides what is allowed.
//
// jQuery global ajax events fire for LearnDash's `jQuery.ajax` call because it
// does not set `global: false` (wpProQuiz_front.js ~:2880).
export function initQuizSubmitRefused() {
  if (!window.jQuery) return;
  window.jQuery(document).ajaxComplete((_event, xhr, settings) => {
    const body = String((settings && settings.data) || '');
    if (xhr && xhr.status === 409 && body.includes('action=wp_pro_quiz_completed_quiz')) {
      window.location.reload();
    }
  });
}
